export class ObservacionesRespuestaFormat {
    fecha: string = "";
    usuario: string = "";
    observacion: string = "";
}